import { system } from '@config/system';
import { openUrl } from './window';
// Kept out of payment.ts on purpose: these are pure helpers, whereas payment.ts
// pulls in the Store, @data/api, feature flags and models (axios, react-query,
// the LaunchDarkly SDK, mobx, …). The payment popup only needs these two
// functions, so importing them from here keeps all of that out of its bundle
// (BENG-4169).
export const createNextAction = (reservationResponse, onSuccessCallback) => {
    const onSuccess = () => onSuccessCallback(reservationResponse);
    if (reservationResponse.nextAction) {
        return Object.assign(Object.assign({}, reservationResponse.nextAction), { onSuccess });
    }
    return { onSuccess, type: 'done' };
};
export const processNextActionRedirect = ({ nextAction, onOpenExternalWindow, onErrorOpeningWindow, target: targetOverride, windowFeatures, }) => {
    if ((nextAction === null || nextAction === void 0 ? void 0 : nextAction.type) !== 'redirect') {
        return;
    }
    const { method, url } = nextAction.redirect;
    const payload = method === 'POST' ? nextAction.redirect.postData : undefined;
    const target = targetOverride !== null && targetOverride !== void 0 ? targetOverride : (system.isImmersiveExperience ? '_blank' : '_self');
    const newWindow = openUrl({
        features: windowFeatures,
        method,
        payload,
        target,
        url,
    });
    if (!newWindow) {
        return onErrorOpeningWindow === null || onErrorOpeningWindow === void 0 ? void 0 : onErrorOpeningWindow();
    }
    if (target !== '_self') {
        onOpenExternalWindow === null || onOpenExternalWindow === void 0 ? void 0 : onOpenExternalWindow(newWindow);
    }
};
